(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userOnBoardingService', userOnBoardingService);

    /* @ngInject */
    function userOnBoardingService($http,
        $q,
        exception,
        logger,
        coreService,
        config,
        $odataresource,
        moment,
        userService,
        customerService) {
        var service = {
            getDefaultOnBoard: getDefaultOnBoard,
            getUserTypes: getUserTypes,
            getDefaultOnboardUser: getDefaultOnboardUser,
            getModalOptions: getModalOptions,
            getWizardForm: getWizardForm,
            saveOnBoardUser: saveOnBoardUser,
            getOnBoardUser: getOnBoardUser,
            getValidationObject: getValidationObject,
            mapBasicInformationModel: mapBasicInformationModel,
            mapProfileInformation: mapProfileInformation,
            mapAutocarSites: mapAutocarSites,
            mapProfileUsingUserDetails: mapProfileUsingUserDetails,
            mapUserRolesInformation: mapUserRolesInformation,
            mapPendingOrganizationInformation: mapPendingOrganizationInformation,
            mapOrganizationInformation: mapOrganizationInformation,
            mapPendingProfileInformation: mapPendingProfileInformation
        };

        activate();

        return service;

        function activate() {
        }

        function getDefaultOnBoard() {
            var onboard = {
                user: {
                    UserId: 0,
                    Auth0UserId: '',
                    Email: '',
                    IsActive: true,
                    IsAdmin: false,
                    FullName: '',
                    CreatedUserId: 0,
                    DateCreated: moment().toDate(),
                    UpdatedUserId: 0,
                    DateUpdated: moment().toDate(),
                    Deleted: false,
                    ConnectionTypeId: 1,
                    user: ''
                },
                settings: {
                    isAdmin: false
                },
                applications: []
            };
            return onboard;
        }

        function getDefaultOnboardUser() {
            var user = {
                profile: {
                    UserId: 0,
                    FirstName: '',
                    LastName: '',
                    FullName: '',
                    Email: '',
                    LocationRoleId: null,
                    DepartmentRoleId: null,
                    TitleRoleId: null
                },
                basic: {
                    UserId: 0,
                    Auth0UserId: '',
                    ConnectionTypeId: 2,
                    IsActive: true,
                    InviteEmailSent: false,
                    Deleted: false,
                    CreatedUserId: 0,
                    DateCreated: moment().toDate(),
                    UpdatedUserId: 0,
                    DateUpdated: moment().toDate()
                },
                organization: {
                    CustomerId: null,
                    CustomerDisplayName: '',
                    Name: '',
                    Zoom: 17,
                    Center: { lat: 15, lng: 15 }
                },
                permissions: [],
                roles: {
                    UserTypeId: null,
                    IsADUser: false,                   
                    AutocarSites: []
                },
                trucks: {                   
                    CustomerId: null,
                    CustomerName: null,
                    Vins: []
                }
            };
            return user;
        }

        function getValidationObject() {
            return {
                roles: false,
                organization: false,
                profile: false,
                trucks: true,
                permissions: true
            };
        }

        function getUserTypes(isAdmin) {
            var availableTypes = [
                { RoleId: 1, RoleName: 'Autocar' },
                { RoleId: 2, RoleName: 'Customer' }
            ];

            if (!isAdmin) {
                availableTypes = _.reject(availableTypes, function (type) {
                    return type.RoleName === 'Autocar';
                });
            }
            return availableTypes;
        }

        function getWizardForm(editMode, searchAdUser,
            verifyExternalUserEmail, roles, autocarSites, corporates,
            site, corporate, disabled, currentUser) {

            var form = {
                userStep: [
                    {
                        key: 'user.user',
                        type: 'typeahead-async',
                        defaultValue: { Email: '' },
                        hideExpression: 'model.user.ConnectionTypeId !== 1',
                        templateOptions: {
                            type: 'Email',
                            label: 'Search AD Email Address',
                            placeholder: 'Enter AD Email Address',
                            required: true,
                            options: searchAdUser,
                            display: 'Email',
                            disabled: editMode,
                            debounce: {
                                default: 3000,
                                blur: 0
                            }
                        },
                        extras: {
                            validateOnModelChange: true
                        },
                        validators: {
                            AdUserSelected: {
                                expression: function ($viewValue, $modelValue, scope) {
                                    if (scope.model.user.ConnectionTypeId === 1) {
                                        return !!$modelValue && !!$modelValue.Email;
                                    }
                                    return true;
                                },
                                message: '"AD User Not Selected."'
                            }
                        },
                        modelOptions: {
                            updateOn: 'default blur'
                        },
                        controller: /* @ngInject */ function ($filter, $scope) {
                            $scope.$watch('model.user.user',
                                function (newValue, oldValue, theScope) {
                                    if ((!!newValue) && newValue.Email !== (!!oldValue && oldValue.Email)) {
                                        angular.extend(theScope.model.user, theScope.model.user.user);
                                    }
                                });
                        }
                    },
                    {
                        key: 'user.Email',
                        type: 'input-loader',
                        hideExpression: 'model.user.ConnectionTypeId !== 2',
                        templateOptions: {
                            type: 'Email',
                            label: 'Email Address',
                            placeholder: 'Enter Email Address',
                            disabled: editMode,
                            required: true,
                            onKeydown: function (value, options) {
                                options.validation.show = false;
                            },
                            onBlur: function (value, options) {
                                options.validation.show = null;
                            },
                            debounce: {
                                default: 3000,
                                blur: 0
                            }
                        },
                        asyncValidators: {
                            uniqueUsername: {
                                expression: function ($viewValue, $modelValue, scope) {
                                    if (scope.model.user.ConnectionTypeId === 2) {
                                        scope.options.templateOptions.loading = true;
                                        if (!editMode) {
                                            return userService.searchEmail($viewValue)
                                                .then(function (result) {
                                                    scope.options.templateOptions.loading = false;
                                                    if (result.status === 200) {
                                                        verifyExternalUserEmail(result, $viewValue);
                                                        scope.model.user.user = $viewValue;
                                                    }
                                                });
                                        }
                                    }
                                    //if we are in edit mode this field is disabled
                                    scope.options.templateOptions.loading = false;
                                    return $q.when(verifyExternalUserEmail({}, $viewValue));

                                },
                                message: '"This Email already exists."'
                            }
                        },
                        modelOptions: {
                            updateOn: 'default blur'
                        }
                    },
                    {
                        key: 'user.FullName',
                        type: 'input',
                        hideExpression: 'model.user.ConnectionTypeId !== 2',
                        ngModelAttrs: {
                            customAttrVal: {
                                attribute: 'disabled'
                            }
                        },
                        templateOptions: {
                            label: 'Full Name',
                            placeholder: 'Full Name',
                            required: true,
                            disabled: editMode
                        }
                    },
                    {
                        key: 'settings.isAdmin',
                        type: 'toggle',
                        templateOptions: {
                            label: 'Is this user an Administrator',
                            activeText: 'Administrator',
                            inactiveText: 'User'
                        }
                    },
                    {
                        key: 'settings.RoleId',
                        type: 'ui-select-single',
                        defaultValue: roles[0].RoleId,
                        templateOptions: {
                            required: true,
                            optionsAttr: 'bs-options',
                            label: 'Role',
                            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                            options: roles,
                            valueProp: 'RoleId',
                            labelProp: 'RoleName',
                            placeholder: 'Select Role'
                        },
                        controller: /* @ngInject */ function ($filter, $scope) {

                            $scope.$watch('model.settings.RoleId',
                                function (newValue, oldValue, theScope) {
                                    if (newValue !== oldValue) {
                                        theScope.model.settings.roleName = $filter('filter')(
                                            theScope.to.options, { RoleId: newValue }, true)[0].RoleName;
                                    }
                                });

                        }
                    },
                    {
                        key: 'autocarSettings.Sites',
                        hideExpression: 'model.settings.roleName !== "Autocar"',
                        type: 'ui-select-multiple',
                        templateOptions: {
                            label: 'Autocar Sites',
                            required: true,
                            optionsAttr: 'bs-options',
                            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                            options: autocarSites,
                            valueProp: 'SiteId',
                            labelProp: 'Description',
                            placeholder: 'Select Sites'
                        },
                        expressionProperties: {
                            'templateOptions.required': 'model.settings.roleName === "Autocar"'
                        }
                    },
                    {
                        key: 'settings.CorporateId',
                        type: 'ui-select-single',
                        hideExpression: 'model.settings.roleName === "Autocar"',
                        defaultValue: (corporate || corporates[0]).CustomerId,
                        templateOptions: {
                            disabled: disabled.corporate,
                            required: true,
                            optionsAttr: 'bs-options',
                            label: 'Corporate',
                            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                            options: corporates,
                            valueProp: 'CustomerId',
                            labelProp: 'CustomerName',
                            placeholder: 'Select Corporate'
                        }
                    },
                    {
                        key: 'settings.RegionId',
                        type: 'ui-select-single',
                        hideExpression: 'model.settings.roleName !== "Region"',
                        defaultValue: corporates[0].Regions.length > 0 ?
                            corporates[0].Regions[0].RegionId : 0,
                        templateOptions: {
                            disabled: disabled.region,
                            required: true,
                            optionsAttr: 'bs-options',
                            label: 'Region',
                            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                            options: (corporate || corporates[0]).Regions,
                            valueProp: 'RegionId',
                            labelProp: 'RegionName',
                            placeholder: 'Select Region'
                        },
                        controller: /* @ngInject */ function ($scope, $filter) {
                            $scope.$watchGroup(['model.settings.CorporateId', 'model.settings.roleName'],
                                function (newValues, oldValues, theScope) {
                                    if (newValues[0] !== oldValues[0] || (newValues[1] === 'Region' && !editMode)) {
                                        theScope.to.options = $filter('filter')(
                                            corporates, { CustomerId: newValues[0] }, true)[0].Regions;

                                        theScope.model.settings.RegionId = theScope.to.options.length > 0 ?
                                            theScope.to.options[0].RegionId : 0;
                                    }
                                });

                        }
                    },
                    {
                        key: 'settings.AreaId',
                        type: 'ui-select-single',
                        hideExpression: 'model.settings.roleName !== "Area"',
                        defaultValue: corporates[0].Areas.length > 0 ? corporates[0].Areas[0].AreaId : 0,
                        templateOptions: {
                            disabled: disabled.area,
                            required: true,
                            optionsAttr: 'bs-options',
                            label: 'Area',
                            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                            options: (corporate || corporates[0]).Areas,
                            valueProp: 'AreaId',
                            labelProp: 'AreaName',
                            placeholder: 'Select Area'
                        },
                        controller: /* @ngInject */ function ($scope, $filter) {
                            $scope.$watchGroup(['model.settings.CorporateId', 'model.settings.roleName'],
                                function (newValues, oldValues, theScope) {
                                    if (newValues[0] !== oldValues[0] || (newValues[1] === 'Area' && !editMode)) {
                                        theScope.to.options = $filter('filter')(
                                            corporates, { CustomerId: newValues[0] }, true)[0].Areas;
                                        theScope.model.settings.AreaId = theScope.to.options.length > 0 ?
                                            theScope.to.options[0].AreaId : 0;
                                    }
                                });

                        }
                    },
                    {
                        key: 'settings.SiteId',
                        type: 'ui-select-infinite',
                        hideExpression: 'model.settings.roleName !== "Site"',
                        defaultValue: 0,
                        templateOptions: {
                            disabled: disabled.site,
                            load: function ($event, $select, model, page, pageCount) {
                                if (model.settings && model.settings.CorporateId) {
                                    if (!currentUser.isInRole('SSO:Site:Admin')) {
                                        return customerService.getSitesForCorporate(model.settings.CorporateId,
                                            6,
                                            $select.search,
                                            page,
                                            pageCount)
                                            .then(function (result) {
                                                if (result.length > 0 && !model.settings.SiteId) {
                                                    model.settings.SiteId = result[0].SiteId;
                                                }
                                                return result;
                                            });
                                    } else {
                                        return $q.when(site);
                                    }

                                }
                                return $q.when({});
                            },
                            loadMore: true,
                            pageCount: 10,
                            required: true,
                            optionsAttr: 'bs-options',
                            label: 'Site',
                            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                            options: site || [],
                            valueProp: 'SiteId',
                            labelProp: 'SiteName',
                            placeholder: 'Select Site'
                        },
                        controller: /* @ngInject */ function ($scope) {
                            $scope.$watchGroup(['model.settings.CorporateId', 'model.settings.roleName'],
                                function (newValues, oldValues, theScope) {
                                    if (!currentUser.isInRole('SSO:Site:Admin') &&
                                        (newValues[0] !== oldValues[0] || newValues[1] === 'Site' && !editMode)) {
                                        theScope.to.options = [];
                                        theScope.model.settings.SiteId = null;
                                        theScope.onLoad({ search: '' });
                                    }
                                });

                        }
                    }
                ]
            };
            return form;
        }

        function getModalOptions() {
            return {
                controller: 'OnBoardController',
                animation: true,
                templateUrl: 'app/user/dashboard/modal/user.onboard.modal.html',
                controllerAs: 'vm'
            };
        }

        function saveOnBoardUser(user) {
            user.Auth0UserId = !!user.Auth0UserId ? user.Auth0UserId : coreService.generateGUID();
            return coreService.httpAccountsPost('user/OnBoard', user);
        }

        function getOnBoardUser(userID) {
            var url = 'user/';
            url = url + encodeURIComponent(userID);
            url = url + '/OnBoard';
            return coreService.httpAccountsGet(url);
        }

        function mapBasicInformationModel(result) {
            return {
                UserId: result.UserId || 0,
                Auth0UserId: result.Auth0UserId,
                ConnectionTypeId: result.ConnectionType !== undefined ? result.ConnectionType.ConnectionTypeId : 2,
                IsActive: result.IsActive || true,
                Deleted: result.Deleted || false,
                InviteEmailSent: result.InviteEmailSent || false,
                CreatedUserId: result.CreatedUserId,
                DateCreated: result.DateCreated || moment().toDate(),
                UpdatedUserId: result.UpdatedUserId,
                DateUpdated: result.DateUpdated || moment().toDate()
            };
        }

        function mapProfileInformation(profile) {
            return {
                UserId: profile.UserId,
                FirstName: profile.FirstName,
                LastName: profile.LastName,
                FullName: profile.FullName,
                Email: profile.Email,
                PhoneNumber: profile.PhoneNumber,
                LocationRoleId: profile.CorporateHierarchyId,
                DepartmentRoleId: profile.DepartmentRoleId,
                TitleRoleId: profile.JobTitleId
            };
        }

        function mapAutocarSites(sites) {
            var siteIds = [];
            angular.forEach(sites, function (autocarSite) {
                siteIds.push(autocarSite.SiteId);
            });
            return siteIds;
        }

        function mapProfileUsingUserDetails(user) {
            return {
                UserId: user.UserId,
                FirstName: user.FirstName,
                LastName: user.LastName,
                FullName: user.FirstName + ' ' + user.LastName,
                Email: user.Email,
                PhoneNumber: user.Profile !== null ? user.Profile.PhoneNumber: '',
                CorporateHierarchyId: user.Profile !== null ? user.Profile.CorporateHierarchyId : null,
                DepartmentRoleId: user.Profile !== null ? user.Profile.DepartmentRoleId : null,
                JobTitleId: user.Profile !== null ? user.Profile.JobTitleId : null
            };

        }

        function mapUserRolesInformation(roles, isADUser) {
            var userType = roles.UserType || null;
            return {
                UserTypeId: userType !== null ? userType.UserTypeId: 0,
                IsADUser: isADUser,
                AutocarSites: isADUser ?
                    roles.UserSiteTies && roles.UserSiteTies.length ?
                        roles.UserSiteTies.map(function (site) {
                            return site.SiteId;
                        }) : []
                    : []
            };
        }

        function mapPendingOrganizationInformation(pendingUser) {
            return {
                CorporateCustomerId: pendingUser.Site.ParentCustomerId,
                CustomerSiteId: pendingUser.SiteId,
                Site: pendingUser.Site
            };
        }

        function mapOrganizationInformation(address) {
            return {
                CustomerId: address.CustomerID,
                Name: address.Name,
                Address1: address.Address1,
                Address2: address.Address2,
                City: address.City,
                StateCode: address.State ? address.State.StateCode : null,
                ZipCode: address.ZIPCode,
                CountryCode: address.Country ? address.Country.CountryCodeISO3 : null
            };
        }

        function mapPendingProfileInformation(pendingUser) {
            return {
                UserId: pendingUser.UserId || 0,
                FirstName: pendingUser.FirstName,
                LastName: pendingUser.LastName,
                FullName: pendingUser.FirstName + ' ' + pendingUser.LastName,
                Email: pendingUser.Email,
                PhoneNumber: pendingUser.PhoneNumber,
                CorporateHierarchyId: pendingUser.LocationRoleId,
                DepartmentRoleId: pendingUser.DepartmentRoleId,
                JobTitleId: pendingUser.TitleRoleId
            };
        }      

    }
})();
